import { render, staticRenderFns } from "./ItSearch.vue?vue&type=template&id=7540553c"
import script from "./ItSearch.vue?vue&type=script&lang=ts"
export * from "./ItSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports